<mat-tab-group mat-stretch-tabs="false" animationDuration="0ms">
  <mat-tab label="Detail"> <app-user-detail></app-user-detail></mat-tab>
  <mat-tab label="Metrics"> <app-user-metrics></app-user-metrics></mat-tab>
  <mat-tab label="Feedback"> <app-user-feedback></app-user-feedback></mat-tab>
  <mat-tab label="Voice Macros"> <app-user-macros></app-user-macros></mat-tab>
</mat-tab-group>
